"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoolSchema = void 0;
const zod_1 = require("zod");
const Token_1 = require("./Token");
exports.PoolSchema = Token_1.TokenSchema.merge(zod_1.z.object({
    tokens: zod_1.z.array(zod_1.z.string({ required_error: 'pool tokens IDs are required' })),
    multiplier: zod_1.z.number({ required_error: 'multiplier tokens IDs are required' }),
    provider: zod_1.z.string().optional().nullable(),
    providerFactory: zod_1.z.string().optional().nullable(),
}));
